<a href="javascript:void(0)"
   class="filter-button"
   [ngClass]="{'disabled': !available, 'active': hasActiveFilters}"
   [matMenuTriggerFor]="filterMenu"
   [title]="filterTitle"
   (click)="toggleFilter($event)">
  <mat-icon [matBadge]="activeFilterCount"
            [matBadgeHidden]="activeFilterCount === 0"
            matBadgeSize="small">filter_list</mat-icon>
</a>

<mat-menu #filterMenu="matMenu" [overlapTrigger]="false" class="filter-panel" xPosition="after" yPosition="below">
  <div (click)="$event.stopPropagation()">
    <h6>{{ filtersHeaderLabel }}</h6>
    <pub-filter-wrapper></pub-filter-wrapper>
  </div>
</mat-menu>
